export enum Role {
	admin = "admin",
	member = "member",
}

export const roles = Object.values(Role);

export enum UserRoles {
	ROLE_ROOT = "ROLE_ROOT",
	ROLE_ADMIN = "ROLE_ADMIN",
	ROLE_USER = "ROLE_USER",
}

// Assignable system roles (ROLE_ROOT is platform only and never assignable from the UI)
export const userRoles = [
	{ value: UserRoles.ROLE_ADMIN, label: "Admin" },
	{ value: UserRoles.ROLE_USER, label: "User" },
];

// Labels for displaying existing data
export const userRoleLabels = [{ value: UserRoles.ROLE_ROOT, label: "Root" }, ...userRoles];

export type UserRole = typeof userRoles;
